<script lang="ts" setup>
const { vuBreakpoints } = useApp()
const { sort, sortOptions, updateSort } = await useCatalogPaginator()

const meta = inject('meta', ref())

const {
  applyOptionsDirectly,
  // Options Level
  optionToggle,
  filterRangeResetMin,
  filterRangeResetMax,
  // Single Filter Level
  filterApply,
  // All Filters Level
  filters,
  filtersApplyAll,
  filtersRemoveAll,
  activeFilters,
  activeFiltersCount,
  expectedTotal,
} = useCatalogFilters(meta)

const {
  open,
  openPanel,
  closePanel,
} = useCatalogFiltersModal()

applyOptionsDirectly.value = true

// const categoryFilters = computed(() => {
//   return filters.value.filter(filter => ['category', 'cat'].includes(filter.key))
// })

// const nonCategoryFilters = computed(() => {
//   return filters?.value?.filter(filter => !['category', 'cat'].includes(filter.key)) || []
// })

onMounted(() => {
  watchEffect(() => {
    applyOptionsDirectly.value = vuBreakpoints.greaterOrEqual('desktop').value
  })
})

function toggleActive(filterKey: string, optionKey: string) {
  optionToggle(filterKey, optionKey)
  filterApply(filterKey)
}

function resetMin(filterKey: string) {
  filterRangeResetMin(filterKey)
  filterApply(filterKey)
}

function resetMax(filterKey: string) {
  filterRangeResetMax(filterKey)
  filterApply(filterKey)
}

function applyAllAndClose() {
  filtersApplyAll()
  closePanel()
}

function resetAllAndClose() {
  closePanel()
  filtersRemoveAll()
  filtersApplyAll()
}

function resetAndApplyAll() {
  filtersRemoveAll()
  filtersApplyAll()
}
</script>

<template>
  <div class="filter-list">
    <div class="filter-list__sticky">
      <button
        type="button"
        class="filter-list__toggle"
        @click="openPanel"
      >
        <Icon
          name="icon:filter"
          class="icon icon--filter"
        />
        <span>{{ $t('Filter & Sort') }}</span>
        <small
          v-if="activeFiltersCount"
          class="filter-list__count"
        >{{ activeFiltersCount }}</small>
      </button>
    </div>

    <div
      :class="{ 'backdrop--active': open }"
      class="backdrop"
      @click="resetAllAndClose"
    />

    <search
      :class="{ 'filter-list__panel--open': open }"
      class="filter-list__panel"
    >
      <div class="filter-list__title">
        <span
          class="filter-list__label"
        >
          {{ $t('Filter & Sort') }}
        </span>
        <button
          type="button"
          class="filter-list__close"
          @click="resetAllAndClose"
        >
          <span>{{ $t('Close') }}</span>
          <Icon name="icon:close" />
        </button>
      </div>

      <UiScrollable
        class="filter-list__scrollable"
        axis="y"
      >
        <PaginatorToolbar
          :sort="sort"
          :sort-options="sortOptions"
          @update-sort="updateSort"
        />

        <FilterActive
          v-if="activeFiltersCount"
          class="plp__filter-active"
          :active-filters="activeFilters"
          @filters-reset-all="resetAndApplyAll"
          @filter-reset-range-min="resetMin"
          @filter-reset-range-max="resetMax"
          @option-toggle="toggleActive"
        />

        <FilterItem
          v-for="filter in filters"
          :key="filter.key"
          :filter="filter"
        />
      </UiScrollable>

      <div
        v-if="!applyOptionsDirectly"
        class="filter-list__buttons"
      >
        <button
          type="button"
          class="filter-list__reset-all"
          @click="resetAllAndClose"
        >
          {{ $t('Reset All') }}
        </button>

        <button
          type="button"
          class="filter-list__apply-all"
          @click="applyAllAndClose"
        >
          <span>{{ $t('Show') }} {{ $tc('items', { count: expectedTotal, quantity: expectedTotal }) }}</span>
        </button>
      </div>
    </search>
  </div>
</template>

<style>
@import url("~layers/app/components/Filter/List.css");
</style>
